import { Pipe, PipeTransform } from '@angular/core';
import { ReviewPackageStatus } from '@common/reviews/enums/review-package-status.enum';

@Pipe({
  name: 'mcReviewPackageStatusText'
})
export class ReviewPackageStatusTextPipe implements PipeTransform {
  transform(status: ReviewPackageStatus | null | undefined): string {
    switch (status) {
      case ReviewPackageStatus.Open:
        return 'Open';
      case ReviewPackageStatus.Closed:
        return 'Closed';
      case ReviewPackageStatus.Merged:
        return 'Merged';
    }
  }
}
